import React, { useMemo } from "react";
import { useThree } from "@react-three/fiber";
import CameraWrapper from "./CameraWrapper";
import ControlsWrapper from "./ControlsWrapper";
import { useSpring, easings, a } from "@react-spring/three";
import useTransitionStore from "../../../state/transitions";
import { useControls, folder } from "leva";

function AnimateCamera({ position, target }) {
  const CamPlacement = useTransitionStore((s) => s.CamPlacement);
  const setShowHotspots = useTransitionStore((s) => s.setShowHotspots);
  const setHotspotControls = useTransitionStore((s) => s.setHotspotControls);
  const HotspotControls = useTransitionStore((s) => s.HotspotControls);
  const AutoRotate = useTransitionStore((s) => s.AutoRotate);

  const { camera, controls } = useThree();

  const { duration } = useControls({
    CameraMovement: folder({
      duration: { value: 1500, min: 0, max: 5000, step: 1 }, //1500
    }),
  });

  const s = useSpring({
    from: CamPlacement[0],
    config: {
      duration: duration,
      easing: easings.easeOutSine,
    },

    onStart: () => {
      setShowHotspots(false);
      if (!controls) return;
      controls.enabled = false;
    },
    onRest: () => {
      if (!controls) return;
      controls.enabled = true;
      if (!AutoRotate) setShowHotspots(true);
    },
  });
  // console.log(`position`, position);

  s.position.start({ from: camera.position.toArray(), to: position });

  s.target.start({
    from: controls ? controls.target.toArray() : [0, 0, 0],
    to: target,
  });

  const AnimateControls = useMemo(() => a(ControlsWrapper), []);
  const AnimatedNavigation = useMemo(() => a(CameraWrapper), []);

  return (
    <>
      <AnimatedNavigation cameraPosition={s.position} target={s.target} />
      <AnimateControls target={s.target} />
    </>
  );
}

export default React.memo(AnimateCamera);
